import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../../server/actions';
import { showFile, _addNotificationError } from '../../../../server/util';
import Datetime from 'react-datetime';

const valid =  (current)=> {
    let maxDate = moment().add(2, 'months');
    if (current <= maxDate) {
        return current.day() !== 0 && current.day() !== 6;
    }
    else {
        return false;
    }
};
class MonthlyIncomeCash extends Component {
    constructor(props){
        super(props)
        this.state={
            loading:false,
            date:moment()
        }
    }

    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    downloadReport = () => {
        let isSchoolrequired = false;
        let _refNotify = this.props.refNotify;
        let _self = this;
        let schoolID = parseInt(sessionStorage.getItem('SchoolId'));
        let schoolYear = parseInt(sessionStorage.getItem('schoolYearValue'))
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let districtID = userInfo.districtId;
        const _firstDay = moment(moment(this.state.date.startOf('month')).format('YYYY-MM-DDT00:00:00'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
        const _lastDay = moment(moment(this.state.date.endOf("month")).format('YYYY-MM-DDT23:59:59'), 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss");
        const _yearMonth = this.state.date.format('YYYYMM');
        const _url = '/reports/incomeCashReport/' + schoolID + '?&startDate=' + _firstDay + '&endDate=' + _lastDay + '&isDistId=false'+
                        '&yearMonth=' + _yearMonth + '&access_token=';
        this.setState({ loading: true });
        get(_url).then((response) => {
            if (!response.ok) {
                if (response.status === 417 || response.status === 422) {
                    return response.json();
                }
            }
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                        throw Error(res.errorMessage);
            } else if (res.statusCode === 422) {
                        throw Error(res.statusMessage);
            } else {
                        return res.blob();
            }
        }).then(blob => {
            let filename = "Monthly Income Cash Report";
            showFile(blob, filename);
                    this.setState({ loading: false })
        }).catch(
        (error) => {
                        let msg = ''
                        if (typeof error === 'string') {
                            msg = error;
                        } else {
                            msg = error.message;
                        }
                        _addNotificationError(msg, _self);
                        this.setState({ loading: false })
                    }
                );
        }
        setDate = (e) => {
            //alert(e)
            this.refs.calendar.closeCalendar()
            this.setState({ date: e })
        }
    render() {
        return (
        <Fragment>
            <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                    <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Month</label>
                    <div className="input-group col-md-8 col-sm-12 col-xs-12">
                        <Datetime inputProps={{ placeholder: 'Select Month' }}
                            ref='calendar' dateFormat="MMMM YYYY" timeFormat={false}
                            value={this.state.date}
                            closeOnSelect={true} isValidDate={valid}
                            onChange={this.setDate}
                        renderInput={this.renderInput} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-center">
                    <button className="btn btn-success btn-sm" onClick={(e) => {
                        e.preventDefault();
                        this.downloadReport(4);
                    }}> Download Report
                    </button>
                </div>
            </div>
        </Fragment>
        )
    }
}

export default MonthlyIncomeCash;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/monthlyIncomeCash.js